module.exports = new __parcel__URL__("data-center-graphic.5467e80d.svg").toString();